export default class CarrelloRiga{
    IdOrdine;
    CodiceArticolo;
    Quantita;
    PrezzoNetto;
    PrezzoListino;
    Sconto1;
    Sconto2;
    Sconto3;
    Sconto4;
    Sconto5;
    ValoreSconto1;
    ValoreSconto2;
    ValoreSconto3;
    ValoreSconto4;
    ValoreSconto5;
    Catalogo;
    DescrizioneArticolo;
    DescrizioneTaglia;
    DescrizioneColore;
    UrlImmagine;
    Valuta;
    PrezzoAgente;
    IsBackorder;
    VenditaSoloMultipli;
    Multipli;
    FromOF;

    setDati(
        IdOrdine,
        CodiceArticolo,
        Quantita,
        PrezzoNetto,
        PrezzoListino,
        Sconto1,
        Sconto2,
        Sconto3,
        Sconto4,
        Sconto5,
        ValoreSconto1,
        ValoreSconto2,
        ValoreSconto3,
        ValoreSconto4,
        ValoreSconto5,
        PrezzoTotale,
        Catalogo,
        DescrizioneArticolo,
        DescrizioneTaglia,
        DescrizioneColore,
        UrlImmagine,
        PrezzoAgente,
        IsBackorder,
        VenditaSoloMultipli,
        Multipli,
        FromOF

        ){
            this.IdOrdine = IdOrdine;
            this.CodiceArticolo = CodiceArticolo;
            this.Quantita = Quantita;
            this.PrezzoNetto = PrezzoNetto;
            this.PrezzoListino = PrezzoListino;
            this.Sconto1 = Sconto1;
            this.Sconto2 = Sconto2;
            this.Sconto3 = Sconto3;
            this.Sconto4 = Sconto4;
            this.Sconto5 = Sconto5;
            this.ValoreSconto1 = ValoreSconto1;
            this.ValoreSconto2 = ValoreSconto2;
            this.ValoreSconto3 = ValoreSconto3;
            this.ValoreSconto4 = ValoreSconto4;
            this.ValoreSconto5 = ValoreSconto5;
            this.PrezzoTotale = PrezzoTotale;
            this.Catalogo = Catalogo;
            this.DescrizioneArticolo = DescrizioneArticolo;
            this.DescrizioneTaglia = DescrizioneTaglia;
            this.DescrizioneColore = DescrizioneColore;
            this.UrlImmagine = UrlImmagine;
            this.PrezzoAgente = PrezzoAgente;
            this.IsBackorder = IsBackorder;
            this.VenditaSoloMultipli = VenditaSoloMultipli;
            this.Multipli = Multipli;
            this.FromOF = FromOF;
        }
}